// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  margin-bottom: 0;
  padding-bottom: 0;
  color: #111111;
}

h2.ngorange {
  color: #007566;
}

.sticky .panelHr {
  margin: 10px;
}

.attention {
  background-color: #007566;
  padding: 2px 4px;
  color: #111111;
  border-radius: 3px;
}

.infoTable {
  width: 100%;
}

.name {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
}

.graph-container h3 {
  margin-top: 12px;
}

.concordanceResults {
  margin-top: 15px;
}

.analysisTabs {
  margin-top: -2px;
}

.analysisTabs h2 {
  font-size: 1.4rem;
  padding-top: 15px;
}

::ng-deep .analysisTabs .mat-tab-header {
  border-bottom: 1px solid #bcbcbc;
}

::ng-deep .analysisTabs .mat-tab-label {
  font-size: 1.15rem;
  padding: 0 10px;
}

::ng-deep .analysisTabs.rightMatchesTabs .mat-tab-body {
  max-height: unset;
}

::ng-deep .analysisTabs .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .analysisTabs .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .analysisTabs .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .personTd .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .personTd .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .personTd .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .analysisTabs .mat-expansion-panel:not([class*=mat-elevation-z]),
::ng-deep .personTd .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}

::ng-deep .analysisTabs .mat-expansion-panel-header,
::ng-deep .personTd .mat-expansion-panel-header {
  padding: 0;
}

::ng-deep .analysisTabs .mat-expansion-panel-header-description,
::ng-deep .analysisTabs .mat-expansion-panel-header-title,
::ng-deep .personTd .mat-expansion-panel-header-description {
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .personTd .mat-expansion-panel-header-title {
  color: #111111;
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .analysisTabs .mat-content {
  max-width: 107px;
}

::ng-deep .personTd .mat-content {
  max-width: 129px;
}

::ng-deep .analysisTabs .mat-tab-label-container {
  overflow-x: auto !important;
}

::ng-deep .analysisTabs .mat-expansion-panel-body,
::ng-deep .personTd .mat-expansion-panel-body {
  border: 1px #bcbcbc solid;
  padding-top: 10px;
  font-size: 1.3rem;
}

::ng-deep .analysisTabs .mat-expansion-panel-body h3,
::ng-deep .personTd .mat-expansion-panel-body h3 {
  font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/right-matches/components/mobile/mobile-right-matches-report/mobile-right-matches-report.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,iBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAMQ;EACI,uBAAA;AAHZ;;AAYQ;EACI,uBAAA;AATZ;;AAcA;;EAEI,gBAAA;AAXJ;;AAcA;;EAEI,UAAA;AAXJ;;AAcA;;;EAGI,SAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,cAAA;EACA,SAAA;EACA,iBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,2BAAA;AAXJ;;AAcA;;EAEI,yBAAA;EACA,iBAAA;EACA,iBAAA;AAXJ;;AAcA;;EAEI,iBAAA;AAXJ","sourcesContent":["h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: #111111;\n}\n\nh2.ngorange {\n    color: #007566;\n}\n\n.sticky .panelHr {\n    margin: 10px;\n}\n\n.attention {\n    background-color: #007566;\n    padding: 2px 4px;\n    color: #111111;\n    border-radius: 3px;\n}\n\n.infoTable {\n    width: 100%;\n}\n\n.name {\n    font-size: 1.4rem;\n    margin: 0;\n    padding: 0;\n}\n\n.graph-container h3 {\n    margin-top: 12px;\n}\n\n.concordanceResults {\n    margin-top: 15px;\n}\n\n.analysisTabs {\n    margin-top: -2px;\n}\n\n.analysisTabs h2 {\n    font-size: 1.4rem;\n    padding-top: 15px;\n}\n\n::ng-deep .analysisTabs .mat-tab-header {\n    border-bottom: 1px solid #bcbcbc;\n}\n\n::ng-deep .analysisTabs .mat-tab-label {\n    font-size: 1.15rem;\n    padding: 0 10px;\n}\n\n::ng-deep .analysisTabs.rightMatchesTabs .mat-tab-body {\n    max-height: unset;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .personTd .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel:not([class*=mat-elevation-z]),\n::ng-deep .personTd .mat-expansion-panel:not([class*=mat-elevation-z]) {\n    box-shadow: none;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-header,\n::ng-deep .personTd .mat-expansion-panel-header {\n    padding: 0;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-header-description,\n::ng-deep .analysisTabs .mat-expansion-panel-header-title,\n::ng-deep .personTd .mat-expansion-panel-header-description {\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .personTd .mat-expansion-panel-header-title {\n    color: #111111;\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .analysisTabs .mat-content {\n    max-width: 107px;\n}\n\n::ng-deep .personTd .mat-content {\n    max-width: 129px;\n}\n\n::ng-deep .analysisTabs .mat-tab-label-container {\n    overflow-x: auto !important;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-body,\n::ng-deep .personTd .mat-expansion-panel-body {\n    border: 1px #bcbcbc solid;\n    padding-top: 10px;\n    font-size: 1.3rem;\n}\n\n::ng-deep .analysisTabs .mat-expansion-panel-body h3,\n::ng-deep .personTd .mat-expansion-panel-body h3 {\n    font-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
